const Size = {
  NormalButton: {
    width: 218,
    height: 44,
  },
  NormalDialogButton: {
    width: 170,
    height: 44,
  },
  SmallButton: {
    width: 128,
    height: 40,
  },
  MediumButton: {
    width: 128,
    height: 44,
  },
  LargeButton: {
    width: 128,
    height: 48,
  },
  BigSmallButton: {
    width: 89,
    height: 30,
  },
  OutLineVerySmallButton: {
    width: 70,
  },
  iconNormalSmallButton: {
    width: 94,
    height: 40,
  },
  iconBigSmallButton: {
    width: 30,
    height: 30,
  },
  VerySmallButton: {
    width: 22,
    height: 22,
  },
  IconTextActivitySmallButton: {
    width: 40,
    height: 40,
    iconWidth: 18,
    iconHeight: 18,
  },

  full: '100%',
  half: '50%',
  medium: '33%',
  font: {
    // CYM: h1은 좌측 상단 회사 로고만 사용하기 위해 제외
    heading_02: 30,
    heading_03: 25,
    heading_04: 21,
    heading_05: 18,
    heading_06: 45,
    heading_07: 22,
    x_large: 16,
    large: 14,
    regular: 13,
    small: 12,
    verySmall: 11,
    x_small: 10,
    // 브라우저 지원 최소 폰트 사이즈가 10이여서 9는 사용하지 않기로 함

    // 특정 페이지 폰트 사이즈 지정
    sidebar: {
      dashboard_large: 18,
      dashboard_regular: 16,
      menu_large: 15,
      menu_regular: 14,
      menu_small: 13,
      category_large: 12,
      category_regular: 11,
    },
    infoCard: {
      title: 18,
      contents: 13,
    },
  },
  fontWeight: {
    bold: 700,
    infoCard: {
      large: 700,
      regular: 400,
    },
  },
  lineHeight: {
    heading_02: 37,
    heading_03: 31,
    heading_04: 28,
    heading_05: 25,
    x_large: 19,
    xx_large: 22,
    large: 17,
    regular: 15,
    small: 13,
    x_small: 11,

    sidebar: {
      dashboard_large: 26,
      dashboard_regular: 23,
      menu_large: 22,
      menu_regular: 20,
      menu_small: 18,
      category_large: 1,
      category_regular: 16,
    },
    infocard: {
      title: 35,
    },
    subtitleLabel: {
      text: 20,
    },
  },
  borderRadius: {
    regular: '4px 4px 4px 4px',
    card: 13,
    input: 2,
    infocard: {
      container: '4px 4px 4px 4px',
    },
    analysisHeader: {
      radius: 50,
      bottom_left_radius: 50,
    },
  },
  width: {
    checkbox: {
      normal: 14,
    },
    radio: {
      normal: 16,
    },
    infoCard: {
      normal: 100,
      contents: 95,
      contentslist: 28,
      container_ratio: 30,
      container_ratio_large: 100,
      contentslist_large: 20,
      contentslist_large_comment: 50,
    },
    MyPage: {
      inputBox: 422,
      custom_label: 150,
    },
  },
  height: {
    input: {
      small: 34,
      normal: 40,
      big: 50,
      x_large: 144,
    },
    checkbox: {
      normal: 14,
    },
    radio: {
      normal: 16,
    },
    infoCard: {
      container: 463,
      list: 38,
      list_large: 45,
    },
    subtitleLabel: {
      background: 43,
    },
    searchBar: {
      boxHeight: 40,
    },
  },
  table: {
    height: 44,
  },
  padding: {
    common_right_mo: 24,
    common_right_ta: 32,
    common_right_pc: 62,
    common_left_mo: 24,
    common_left_ta: 32,
    common_left_pc: 62,
    main_right_mo: 24,
    main_right_ta: 32,
    main_right_pc: 72,
    main_left_mo: 24,
    main_left_ta: 32,
    main_left_pc: 24,
    card: {
      top_mo: 30,
      top_ta: 40,
      top_pc: 25,
      right_mo: 20,
      right_ta: 30,
      right_pc: 25,
      bottom_mo: 30,
      bottom_ta: 40,
      bottom_pc: 25,
      left_mo: 20,
      left_ta: 30,
      left_pc: 25,
    },
    input: {
      normal: {
        left: 14,
        right: 14,
      },
      selectBirth: {
        margin: 1,
      },
      large: {
        right: 422,
      },
      verySmall: {
        left: 6,
        right: 6,
      },
    },
    iconButton: {
      padding: 15,
    },
    iconNormalSmallButton: {
      padding: 21,
    },
    iconTextActivityButton: {
      padding: 12,
    },
    infoCard: {
      inner: '50px',
      largeInner: '52px 40px 74px 4%',
      title_underline: 35,
      contents_left: 10,
    },
    smallButton: {
      padding: 17,
    },
    analysisHeader: {
      titleWrap: {
        bottom_left: 50,
        bottom_right: 50,
        bottom_top: 20,
      },
    },
    searchBar: {
      searchBox: '0 15px 0 12px',
    },
  },
  margin: {
    header: {
      title_margin_left: 45,
    },
    list: {
      margin_top: 43,
      input_title_right: 74,
    },
    infoCard: {
      contentsList: 5,
      contentsList_large: 0,
      title_icon_left: 20,
      title_icon_right: 4,
      title_bottom: 19,
      contents_left: 7,
      contents_left_large: 2,
    },
    MyPage: {
      button: 64,
      button_right: 12,
      custom_label_right: 34,
      form_top: 33,
      form_left: 40,
      form_bottom: 44,
      textbox_margin: 8,
    },
    subtitleLabel: {
      icon_left: 40,
      icon_right: 4,
    },
  },
  selectBox: {
    verySmall: {
      width: 50,
      height: 22,
    },
  },
  flexGap: {
    infoCard: {
      layout: 70,
      contents: 10,
      contents_height: 10,
      contents_large_height: 7,
    },
  },
  position: {
    icon_right_title: 1,
  },
}

export default Size
